import React from 'react';
import { Dialog, T } from '@colonist/ui';
import { emptyTranslation } from '@colonist/i18n';
import { StarRating } from '../StarRating/StarRating.tsx';
import styles from './RatingStage.module.scss';
import IconScarfSmile from '@static/images/icon_scarf_smile.svg';
/** Stage 1 of the feedback form; star rating. */ export function RatingStage({ open, rating, onClose, onStarSelect }) {
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: onClose
    }, /*#__PURE__*/ React.createElement(Dialog.Title, null, /*#__PURE__*/ React.createElement(Dialog.ImageTitle, {
        image: {
            src: IconScarfSmile,
            alt: emptyTranslation
        }
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:popups.feedbackForm.title'
        }
    }))), /*#__PURE__*/ React.createElement(Dialog.Content, null, /*#__PURE__*/ React.createElement("div", {
        className: styles.ratingStage
    }, /*#__PURE__*/ React.createElement("p", null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:popups.feedbackForm.body'
        }
    })), /*#__PURE__*/ React.createElement(StarRating, {
        value: rating,
        onChange: onStarSelect
    }))));
}
